import { createAxiosInstance, getView } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'

import { displayMessages } from './common'




export function getSolicitudes(page = 1) {

	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		
		const showRecords = getState().solicitudes.get('showRecords')
		const orderBy = getState().solicitudes.get('orderBy')
		const filters = getState().solicitudes.getIn(['modalFilter', 'filters']).filter(x => x.get('apply')).toJS()
		const having = []

		axios.get(`${API_URL}/solicitudes`, { params: { estado: 1, page, showRecords, orderBy, filters, having }})
		.then((res) => {
			const data = res.data.data.map(x => {
				x.visible = true
				x.selected = false
				return x
			})
			const totalRecords = Number(res.data.totalRecords)
			const fn1 = d => d({ type: types.OBTENER_SOLICITUDES, payload: { data, page, totalRecords } })
			fn1(dispatch)
		})
		.catch((err) => {
			displayMessages(dispatch, err)
		})

	}
}


export function changeRecordsToShow(showRecords) {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.CAMBIAR_MOSTRAR_REGISTROS_SOLICITUDES, payload: showRecords })
        const fn1 = (d) => d(getSolicitudes(1))
        fn0(dispatch)
        fn1(dispatch)
    }
}

export function toggleSelectItem(id, checked) {
	return (dispatch, getState) => {
		const index = getState().solicitudes.get('solicitudes').findIndex(x => x.get('id') === id)
		dispatch({ type: types.CONMUTAR_SELECCION_SOLICITUD, payload: { index, checked } })
	}
}

export function toggleSelectAllItems(checked) {
	return (dispatch) => {
		dispatch({ type: types.CONMUTAR_SELECCION_TODOS_SOLICITUDES, payload: checked })
	}
}

export function filterSolicitudes(term) {
	return (dispatch) => {
		dispatch({ type: types.FILTRAR_SOLICITUDES, payload: term })
	}
}

export function setOrderBy(field) {	
	return (dispatch, getState) => {
		let current = getState().solicitudes.get('orderBy')
		current = current.set('field', field.value)
		if (field === null) {
			current = current.set('asc', false)
		} else {
			current = current.set('asc', !current.get('asc'))
		}
        const fn0 = (d) => d({ type: types.ORDENAR_SOLICITUDES, payload: { orderBy: current } })
        const fn1 = (d) => d(getSolicitudes(1))
        fn0(dispatch)
		fn1(dispatch)
		
	}
}

export function showHideModalDelete(open, message = null, action = null) {
	return (dispatch) => {
		dispatch({ type: types.MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_SOLICITUD, payload: { open, message, action } })
	}
}

export function deleteSolicitudes() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const selected = getState().solicitudes.get('solicitudes').filter(x => x.get('selected')).map(x => x.get('id'))
		const fns = []
		selected.forEach(x => {
			const fn = () => axios.delete(`${API_URL}/solicitudes/${x}`)
			fns.push(fn)
		})

		const toResultObject = (promise) => {
			return promise
			.then(result => ({ success: true, result }))
			.catch(error => ({ success: false, error }));
		}

		Promise.all(fns.map(x => x()).map(toResultObject))
		.then(res => {
			const succeded = []
			const failed = []
			res.forEach(x => {
				if (!x.success) {
					failed.push(x.error.response.data.ExceptionMessage)
				} else {
					succeded.push(x.result.data.proyecto_evento)
					dispatch({ type: types.ELIMINAR_SOLICITUD, payload: x.result.data.id })
				}
			})
			if (succeded.length > 0) displayMessages(dispatch, { success: 'Se han eliminado los siguentes solicitudes: ' + succeded.join(', ') })
			if (failed.length > 0) displayMessages(dispatch, { response: { status: 500, data: failed.join('\n') } })
		})
	}
}

export function showHideModalFilter(state, tableCols) {
    return (dispatch) => {
        dispatch({ type: types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_SOLICITUDES, payload: {state, tableCols} })
    }
}

export function addModalFilterCriteria() {
    return (dispatch) => {
        dispatch({ type: types.ADICIONAR_CRITERIO_FILTRADO_SOLICITUDES })
    }
}

export function removeCheckedModalFilterCriterias() {
    return (dispatch) => {
        dispatch({ type: types.ELIMINAR_CRITERIO_FILTRADO_SOLICITUDES })
    }
}

export function toggleCheckedModalFilterCriterias(index, checked) {
    return (dispatch) => {
        dispatch({ type: types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_SOLICITUDES, payload: { index, checked } })
    }
}

export function updateModalFilterCriteria(index, attr, value) {
    return (dispatch) => {
        dispatch({ type: types.MODIFICAR_CRITERIO_FILTRADO_SOLICITUDES, payload: { index, attr, value } })
    }
}

export function applyFilterCriterias() {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.APLICAR_CRITERIOS_FILTRADO_SOLICITUDES })
        const fn1= (d) => d(getSolicitudes(1))
        fn0(dispatch)
        fn1(dispatch)
    }
}


// WEBPACK FOOTER //
// ./src/actions/solicitudes.js